//? PLUGINS //
import { Button, ButtonProps, Grid, Menu, MenuItem } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useTranslation } from 'react-i18next';

//? SERVICES //
import * as authenticationService from 'services/AuthenticationService';

//? STYLES //
import * as Styles from 'styles/components/header.styles';

//? ICONS & IMAGES //
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from 'contexts/authContext';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

//! -------------------------------------------------------- //

//* Variables //
const redirectUrl = '/login';

//* Interfaces //
interface AuthenticatedUserProps {
    user: authenticationService.User;
    isMobile: boolean;
}

//* Functions //

export const AuthenticatedUser = (props: AuthenticatedUserProps) => {
    const { user, isMobile } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { logout } = useAuthContext();

    //* Component Options //
    const buttonOptions: ButtonProps = {
        variant: 'contained',
        sx: Styles.button(isMobile, true)
    };

    const handleLogout = () => {
        logout(redirectUrl);
    }


    // Profile menu
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box>
            {isMobile ? (
                <Grid container spacing={3}>
                    {user.role.includes("External") && 
                        <Grid
                            item
                            xs={12}
                            sx={{
                                color: "#FFF",
                                fontSize: "20px",
                                textAlign: "start",
                                "&:hover": { cursor: "pointer" },
                            }}
                            onClick={() => {
                                navigate('/profile')
                            }}
                        >
                            {t("header.profile")}
                        </Grid>
                    }
                    <Grid
                        item
                        xs={12}
                        sx={{
                            color: "red",
                            fontSize: "20px",
                            textAlign: "start",
                            "&:hover": { cursor: "pointer" },
                        }}
                        onClick={handleLogout}
                    >
                        {t("header.logout")}
                    </Grid>
                </Grid>
            ) : (
            <Box sx={Styles.authenticatedUserContainer}>
                {!user.role.includes("External") && (<AccountCircleOutlinedIcon />)}
                {!user.role.includes("External") && (<Box sx={Styles.userName}>
                    {user.given_name} {user.surname}
                </Box>)}

                {user.role.includes("External") && (
                    <Box sx={{mr: 1}}>
                        <AccountCircleOutlinedIcon style={{verticalAlign: 'text-top'}}/>
                        <Button
                            id="positioned-button"
                            aria-controls={open ? 'positioned-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                            style={{textTransform: 'none', fontSize: '1rem', color: 'black'}}
                            endIcon={<KeyboardArrowDownIcon />}
                            
                        >
                            {user.given_name} {user.surname}
                        </Button>
                        <Menu
                            id="positioned-menu"
                            aria-labelledby="positioned-button"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                            }}
                            transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                            }}
                        >
                            <MenuItem onClick={() => navigate('/profile')}>{t('header.profile')}</MenuItem>
                            <MenuItem sx={{color: 'red'}} onClick={handleLogout}>{t('header.logout')}</MenuItem>
                        </Menu>
                    </Box>
                )}
                
                {!user.role.includes("External") && 
                    <Button {...buttonOptions} onClick={handleLogout}>
                        {t('header.logout')}
                    </Button>
                }
                
            </Box>
            )}
        </Box>
    );
};
